var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payment-overlay" }, [
    _c("div", {
      staticClass: "payment-overlay--backdrop",
      on: { click: _vm.onBackgroundClicked }
    }),
    _vm._v(" "),
    _vm.prevOverlay
      ? _c(
          "button",
          {
            staticClass:
              "payment-overlay--navigation-button payment-overlay--navigation-button__prev",
            on: { click: _vm.openPrevOverlay }
          },
          [
            _c("base-icon", {
              attrs: { symbol: "chevron-left", size: "small" }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.nextOverlay
      ? _c(
          "button",
          {
            staticClass:
              "payment-overlay--navigation-button payment-overlay--navigation-button__next",
            on: { click: _vm.openNextOverlay }
          },
          [
            _c("base-icon", {
              attrs: { symbol: "chevron-right", size: "small" }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "payment-overlay--content grid grid__base" },
      [
        _c("overlay-close-btn", { on: { close: _vm.onClose } }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "payment-overlay-content payment-overlay-content__header grid grid__base"
          },
          [
            _c(
              "div",
              { staticClass: "payment-overlay--header-row grid--row" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "payment-overlay--header-col payment-overlay-content--content grid--col"
                  },
                  [
                    _c(
                      "h2",
                      { staticClass: "u-reset payment-overlay--title" },
                      [_vm._v(_vm._s(_vm.title))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "payment-overlay--header-logo-col grid--col" },
                  [
                    _c(
                      "picture-element",
                      _vm._b(
                        { staticClass: "payment-overlay--logo" },
                        "picture-element",
                        _vm.logo,
                        false
                      )
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _vm.overlayContent
          ? _c(
              "div",
              {
                key: "content",
                staticClass: "payment-overlay--content-wrapper"
              },
              [
                _c("v-runtime-template", {
                  attrs: { template: _vm.overlayContent }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isContentLoading
          ? _c(
              "div",
              { key: "loader", staticClass: "payment-overlay--loader-wrapper" },
              [
                _c("spinning-loader", {
                  staticClass: "payment-overlay--loader"
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.prevOverlay || _vm.nextOverlay
          ? _c(
              "div",
              { staticClass: "payment-overlay--pagination grid--container" },
              [
                _c(
                  "div",
                  { staticClass: "payment-overlay--pagination-row grid--row" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "payment-overlay--pagination-col grid--col"
                      },
                      [
                        _vm.prevOverlay
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "payment-overlay--mobile-navigation",
                                on: { click: _vm.openPrevOverlay }
                              },
                              [
                                _c("base-icon", {
                                  staticClass:
                                    "payment-overlay--mobile-navigation-icon",
                                  attrs: {
                                    symbol: "chevron-left",
                                    size: "small"
                                  }
                                }),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.prevOverlay.name) +
                                    "\n                    "
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "payment-overlay--col grid--col" },
                      [
                        _vm.nextOverlay
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "payment-overlay--mobile-navigation",
                                on: { click: _vm.openNextOverlay }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.nextOverlay.name) +
                                    "\n                        "
                                ),
                                _c("base-icon", {
                                  staticClass:
                                    "payment-overlay--mobile-navigation-icon",
                                  attrs: {
                                    symbol: "chevron-right",
                                    size: "small"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-883501e2", { render: render, staticRenderFns: staticRenderFns })
  }
}